import { reducers } from './reducers'
export * from './selectors'
export * from './actions'
export * from './epics'
export * from './reducers'

export default reducers
